/*
 * Jira Ticket:
 * Created Date: Thu, 9th Apr 2020, 12:19:42 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneTowerTypeQuery = gql`
  query TowerType($id: ID!, $version: DateTime) {
    data: TowerType(id: $id) {
      id
      name
      qualificationIds
      questionCount
      questions(version: $version) {
        id
        question
        image {
          id
          url
          __typename
        }
        __typename
      }
      updatedAt
      status
      __typename
    }
  }
`;

export default async ({ client, params }) => {
  try {
    return client.query({
      query: getOneTowerTypeQuery,
      variables: {
        ...params,
      },
      fetchPolicy: 'network-only',
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
